import { compressToUTF16, decompressFromUTF16 } from 'lz-string';

import type { GameState, GameStateCompressed } from '@genially/p2p-lib';
import type { MeasurePerformanceService } from '@genially/utils';

export class GameCompressor {
  private measurePerformanceService: MeasurePerformanceService;

  constructor({
    measurePerformanceService,
  }: {
    measurePerformanceService: MeasurePerformanceService;
  }) {
    this.measurePerformanceService = measurePerformanceService;

    this.measurePerformanceService.measureThis(this);
  }

  compress(game: GameState): GameStateCompressed {
    return compressToUTF16(JSON.stringify(game));
  }

  decompress(compressedGame: GameStateCompressed): GameState {
    return JSON.parse(decompressFromUTF16(compressedGame));
  }
}
